/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ItauAtivacaoRecorrenciaResponse } from './itauAtivacaoRecorrenciaResponse';
import { ItauAtualizacaoRecorrencia } from './itauAtualizacaoRecorrencia';
import { ItauCalendarioRecorrencia } from './itauCalendarioRecorrencia';
import { ItauCobrancaRecorrenteResponse } from './itauCobrancaRecorrenteResponse';
import { ItauDadosQRCode } from './itauDadosQRCode';
import { ItauEncerramentoRecorrencia } from './itauEncerramentoRecorrencia';
import { ItauRecebedorResponse } from './itauRecebedorResponse';
import { ItauValorRecorrencia } from './itauValorRecorrencia';
import { ItauVinculoRecorrencia } from './itauVinculoRecorrencia';

export interface ItauRecorrenciaResponse {
  ativacao?: ItauAtivacaoRecorrenciaResponse;
  atualizacao?: Array<ItauAtualizacaoRecorrencia>;
  calendario?: ItauCalendarioRecorrencia;
  cobsr?: Array<ItauCobrancaRecorrenteResponse>;
  dadosQR?: ItauDadosQRCode;
  encerramento?: ItauEncerramentoRecorrencia;
  idRec?: string;
  loc?: any;
  politicaRetentativa?: ItauRecorrenciaResponse.PoliticaRetentativaEnum;
  recebedor?: ItauRecebedorResponse;
  status?: ItauRecorrenciaResponse.StatusEnum;
  valor?: ItauValorRecorrencia;
  vinculo?: ItauVinculoRecorrencia;
}
export namespace ItauRecorrenciaResponse {
  export type StatusEnum =
    | 'CRIADA'
    | 'APROVADA'
    | 'REJEITADA'
    | 'EXPIRADA'
    | 'CANCELADA';
  export const StatusEnum = {
    CRIADA: 'CRIADA' as StatusEnum,
    APROVADA: 'APROVADA' as StatusEnum,
    REJEITADA: 'REJEITADA' as StatusEnum,
    EXPIRADA: 'EXPIRADA' as StatusEnum,
    CANCELADA: 'CANCELADA' as StatusEnum
  };
  export type PoliticaRetentativaEnum = 'NAO_PERMITE' | 'PERMITE_3R_7D';
  export const PoliticaRetentativaEnum = {
    NAOPERMITE: 'NAO_PERMITE' as PoliticaRetentativaEnum,
    PERMITE3R7D: 'PERMITE_3R_7D' as PoliticaRetentativaEnum
  };
}
